import React, { CSSProperties, JSX } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { t } from 'i18next';

interface CheckboxWithCustomCheckmarkProps {
  checked: boolean;
  checkedBoxColor: string;
  uncheckedBoxColor: string;
  checkmark: JSX.Element;
  label: string;
  onClick: () => void;
  labelStyle?: CSSProperties;
  position?: 'leading' | 'trailing';
  style?: CSSProperties;
}

const CheckboxWithCustomCheckmark: React.FC<CheckboxWithCustomCheckmarkProps> = ({
  checked,
  onClick,
  label,
  checkedBoxColor,
  uncheckedBoxColor,
  checkmark,
  labelStyle,
  position = 'leading',
  style,
}) => {
  return (
    <Grid onClick={onClick} className='checkbox-with-custom-checkmark' sx={style}>
      {position === 'leading' && (
        <Paper
          sx={{
            marginRight: '10px',
            backgroundColor: checked ? checkedBoxColor : 'transparent',
            border: `2.5px solid ${checked ? checkedBoxColor : uncheckedBoxColor}`,
          }}>
          {checked && checkmark}
        </Paper>
      )}
      <Typography variant='p16Bold' color='primary' style={labelStyle}>
        {t(label)}
      </Typography>
      {position === 'trailing' && (
        <Paper
          sx={{
            marginLeft: '10px',
            backgroundColor: checked ? checkedBoxColor : 'transparent',
            border: `2.5px solid ${checked ? checkedBoxColor : uncheckedBoxColor}`,
          }}>
          {checked && checkmark}
        </Paper>
      )}
    </Grid>
  );
};

export default CheckboxWithCustomCheckmark;
